import fetch from 'node-fetch';
import axios from "axios";
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';
import {
    SYMBL_APP_ID,
    SYMBL_APP_SECRET,
    SYMBL_TOKEN_COOKIE
} from "../constants"
import Cookies from 'js-cookie';

function convertToQueryString(params) {
    let queryString = '';
  
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
  
        if (typeof value === 'object') {
          queryString += `${key}=${JSON.stringify(value)}&`;
        } else {
          queryString += `${key}=${value}&`;
        }
      }
    }
  
    return queryString.slice(0, -1);
}

export const generateCallScore = async (fileBlob, sampleFileName, scorecardId, criteriaIds) => {
    console.log(fileBlob, sampleFileName, scorecardId, criteriaIds);
    console.log('this is scorecardId', scorecardId);
    
    try {
        const accessToken = await getSymblAccessToken();

        const queryParams = {
            "features": {
                "featureList": ["callScore"],
                "callScore": {
                    "scorecardId": `${scorecardId}`
                }
            },
            "metadata": {
                "salesStage": "general",
            }
        };
        
        const queryString = convertToQueryString(queryParams);

        console.log('this is fileBlob', fileBlob);

        // Determine if the file is video, audio, or m4a
        const isVideo = fileBlob.type.startsWith('video/');
        const isM4a = fileBlob.type === 'audio/x-m4a' || fileBlob.type === 'audio/m4a';
        
        let processedBlob = fileBlob;

        // If it's an m4a file, convert it to mp3
        if (isM4a) {
            const ffmpeg = new FFmpeg();
            await ffmpeg.load();
            
            ffmpeg.writeFile('input.m4a', await fetchFile(fileBlob));
            await ffmpeg.exec(['-i', 'input.m4a', 'output.mp3']);
            const data = await ffmpeg.readFile('output.mp3');
            
            processedBlob = new Blob([data.buffer], { type: 'audio/mpeg' });
        }

        // Choose the appropriate endpoint
        const endpoint = isVideo 
            ? `https://api.symbl.ai/v1/process/video?${queryString}`
            : `https://api.symbl.ai/v1/process/audio?${queryString}`;

        const fetchResponse = await fetch(endpoint, {
            method: 'post',
            body: processedBlob,
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': processedBlob.type,
            }
        });

        const responseBody = await fetchResponse.json();

        console.log('this is responseBody', responseBody);
        return responseBody;
    } catch (error) {
        console.error('Error in Async API Request:', error);
    }
}

export const generateCallScoreViaTextApi = async (messages, scorecardId, conversationType) => {
   try {
       const accessToken = await getSymblAccessToken();

       const requestBody = {
           "messages": messages,
           "features": {
               "featureList": [
                   "callScore"
               ],
           },
           "metadata": {
               "salesStage": "general",
               "prospectName": "Audio File LLC"
           }, 
       };

       if (scorecardId) {
           requestBody.features.callScore = { scorecardId };
       }

       if (conversationType) {
           requestBody.conversationType = conversationType;
       }

       const fetchResponse = await fetch(`https://api.symbl.ai/v1/process/text`, {
           method: 'POST',
           body: JSON.stringify(requestBody),
           headers: {
               'Authorization': `Bearer ${accessToken}`,
               'Content-Type': 'application/json',
           }
       });

       if (!fetchResponse.ok) {
           console.log(`Error in generateCallScoreViaTextApi: ${fetchResponse.status} ${fetchResponse.statusText}`);
           throw new Error(fetchResponse);
       }

       const responseBody = await fetchResponse.json();

       console.log('Call score generated successfully', responseBody);
       return responseBody;
   } catch (error) {
       console.log('Error in generateCallScoreViaTextApi:', error);
       throw error;
   }
};

export const addScoreCard = async ({ name, criteriaList }) => {
    try {
        console.log('Adding score card...');
        console.log('Name:', name);
        console.log('Criteria List:', criteriaList);

        const accessToken = await getSymblAccessToken();

        const response = await fetch('https://api.symbl.ai/v1/manage/callscore/scorecards', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, criteriaList })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Error adding score card:', errorData);
            throw errorData;
        }

        const data = await response.json();
        console.log('Score card added successfully:', data);
        return data;
    } catch (error) {
        console.error('An error occurred while adding score card:', error);
        throw error;
    }
};

export const createCriteria = async ({ name, description, checklist }) => {
    try {
        console.log('Creating criteria...');
        console.log('Name:', name);
        console.log('Description:', description);
        console.log('Checklist:', checklist);

        const accessToken = await getSymblAccessToken();

        const response = await fetch('https://api.symbl.ai/v1/manage/callscore/criteria', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, description, checklist })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.log('Error creating criteria:', errorData);
            throw errorData;
        }

        const data = await response.json();
        console.log('Criteria created successfully:', data);
        return data;
    } catch (error) {
        console.log('An error occurred while creating criteria:', error);
        throw error;
    }
};

export const getSymblAccessToken = async (generateForcefully = false) => {
    const existingAccessToken = Cookies.get(SYMBL_TOKEN_COOKIE)
    if(!generateForcefully && !!existingAccessToken) {
        return existingAccessToken;
    }

    const response = await fetch('https://api.symbl.ai/oauth2/token:generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            type: 'application',
            appId: SYMBL_APP_ID,
            appSecret: SYMBL_APP_SECRET
        })
    });

    const data = await response.json();
    Cookies.set(SYMBL_TOKEN_COOKIE, data.accessToken);
    
    return data.accessToken;
}

export const fetchJobStatus = async (conversationId) => {
    const accessToken = await getSymblAccessToken();

    const { data } = await axios.get(`https://api.symbl.ai/v1/conversations/${conversationId}/callscore/status`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });
    return data;
};

export const retrieveCallScore = async (conversationId) => {
    // const accessToken = await getSymblAccessToken();
    // console.log('harrow', conversationId);
    const { data } = await axios.post(`https://quest-api.symbl.ai/v1/generate-callscore`, {
    // const { data } = await axios.post(`https://34.133.254.153/v1/generate-callscore`, {
        conversationId: conversationId
    });
    return data;
};

export const fetchCallScore = async (conversationId) => {
    const accessToken = await getSymblAccessToken();
    const { data } = await axios.get(`https://api.symbl.ai/v1/conversations/${conversationId}/callscore`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    return data;
};


export const fetchTranscriptMessages = async (conversationId) => {
    const accessToken = await getSymblAccessToken();

    const { data } = await axios.get(`https://api.symbl.ai/v1/conversations/${conversationId}/messages`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });
    return data;
}

export const fetchTranscript = async (conversationId) => {
    try {
      const accessToken = await getSymblAccessToken();
      const response = await axios.post(
        `https://api.symbl.ai/v1/conversations/${conversationId}/transcript`,
        {
          contentType: 'text/markdown',
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching transcript:', error);
      throw error;
    }
};

export const fetchAttendees = async (conversationId) => {
    const accessToken = await getSymblAccessToken();

    const { data } = await axios.get(`https://api.symbl.ai/v1/conversations/${conversationId}/members`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });
    return data;
}

export const fetchCriteriaById = async (criteriaId) => {
    try {
        console.log('Fetching criteria...');
        
        const accessToken = await getSymblAccessToken();

        const response = await fetch(`https://api.symbl.ai/v1/manage/callscore/criteria/${criteriaId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.log('Error while fetching criteria:', errorData);
            throw errorData;
        }

        const data = await response.json();
        console.log('Criteria fetching successfully:', data);
        return data;
    } catch (error) {
        console.log('An error occurred while fetching criteria:', error);
        throw error;
    }
};

export const generateCallScoreForExistingConversation = async (conversationId) => {
    try {
        const accessToken = await getSymblAccessToken();
 
        const requestBody = {
            "features": {
                "featureList": [
                    "callScore"
                ],
            }
        };
 
        const fetchResponse = await fetch(`https://api.symbl.ai/v1/si/call-score/generate/${conversationId}`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            }
        });
 
        if (!fetchResponse.ok) {
            console.log(`Error in generating callscore for existing conversation: ${fetchResponse.status} ${fetchResponse.statusText}`);
            throw new Error(fetchResponse);
        }
 
        const responseBody = await fetchResponse.json();
 
        console.log('Call score job triggered successfully', responseBody);
        return responseBody;
    } catch (error) {
        console.log('Error in generating callscore for existing conversation:', error);
        throw error;
    } 
}